// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3escI","validationTips":"StatementDescriptor_validationTips__2exYR"};